// GENERATED by packages/team-emblem/scripts/palette.mjs from design/tokens/tokens.json. Do not edit by hand.

/** Emblem colours per tile recipe (tokens.json `tile.*`): key fill, top-left highlight, ink for initials. */
export const TILE_EMBLEM_COLORS = {
  "violet": { key: "#C49EFF", light: "#EDE2FF", ink: "#1F1929" },
  "violetHome": { key: "#C49EFF", light: "#EDE2FF", ink: "#1F1929" },
  "teal": { key: "#48F0CE", light: "#C8FBF0", ink: "#0C2621" },
  "pink": { key: "#F9A8D4", light: "#FDE5F2", ink: "#281B22" },
  "azure": { key: "#3D6BFF", light: "#C5D3FF", ink: "#0A1129" },
  "rose": { key: "#FFB0A6", light: "#FFE7E4", ink: "#291C1B" },
  "moss": { key: "#E8F446", light: "#F8FCC8", ink: "#25270B" },
  "ember": { key: "#E2651C", light: "#F6D1BB", ink: "#241004" },
  "magenta": { key: "#FF87CD", light: "#FFDBF0", ink: "#291621" },
  "homeTeams": { key: "#96D7FF", light: "#E0F3FF", ink: "#182229" },
  "homeArena": { key: "#FFBA82", light: "#FFEADA", ink: "#291E15" },
  "streakRisk": { key: "#FFA45C", light: "#FFE4CE", ink: "#291A0F" },
  "hardMode": { key: "#B478FF", light: "#E9D7FF", ink: "#1D1329" },
  "pinkShell": { key: "#F6A3D0", light: "#FCE3F1", ink: "#271A21" },
  "mossShell": { key: "#E3F168", light: "#F7FBD2", ink: "#242711" },
  "arenaDanger": { key: "#FF5A3C", light: "#FFCEC5", ink: "#290E0A" },
  "arenaClip": { key: "#241556", light: "#BDB9CC", ink: "#06030E" },
} as const;
